export default __webpack_public_path__ + "images/05a99d82846a0efba36d396196795ef2-halloween_seasonal_mobile.webp";